import { writable } from 'svelte/store';
import collect from 'collect.js';
import MarketTypeGroup from '@/Models/MarketTypeGroup';
import { mergeCollectionStore } from '@/Common/Collections.js';
import config from '@/config.js';
// Stores
import MarketStore from '@/Stores/Sport/MarketStore.js';
import SportSelectionStore from '@/Stores/Sport/SportSelectionStore.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	let _store;
	let _marketStore;

	const { subscribe, set, update } = writable(collect());

	subscribe((current) => (_store = current));

	const methods = {
		getMarketTypeGroupDetails(groupId, eventId) {
			if (!config.SPORT_ENABLED) return;

			const marketTypeGroup = new MarketTypeGroup();
			return marketTypeGroup
				.find(groupId)
				.then((market_type_group) => {
					let allMarketTypeGroups = collect();
					let allMarkets = collect();
					let allSportSelections = collect();
					// Markets
					market_type_group.markets.data.sortBy('order').map((market) => {
						// Selections
						market.selections.data.map((selection) => {
							selection.market_id = market.id;
							allSportSelections.push(selection);
						});
						delete market.selections;
						allMarkets.push(market);
					});
					delete market_type_group.markets;
					market_type_group.market_ids = allMarkets.pluck('id').toArray();
					market_type_group.sportevent_id = eventId;
					allMarketTypeGroups.push(market_type_group);

					MarketStore.set(allMarkets);
					SportSelectionStore.set(allSportSelections);
					mergeCollectionStore(this, allMarketTypeGroups);
				})
				.catch((e) => {
					console.error(e);
				});
		},

		resetMarketTypeGroups() {
			set(collect());
		},

		marketsForMarketTypeGroup(marketTypeGroupId) {
			let marketIds = _store.where('id', marketTypeGroupId).pluck('market_ids').first();
			return marketIds ? _marketStore.whereIn('id', marketIds) : false;
		}
	};

	MarketStore.subscribe((value) => {
		_marketStore = value;
	});

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
